export default {
  BAG_TYPE_A: 0,
  BAG_TYPE_B: 1,
  BAG_TYPE_C: 2,
  BAG_TYPE_D: 3
}
